// Central content + contact constants for DASH Physiotherapy & Speech and Hearing Clinic

export const CLINIC = {
  name: "DASH Physiotherapy & Speech and Hearing Clinic",
  shortName: "DASH Clinic",
  tagline: "Live Life Without Pain",
  advance: "An Advance Laser Treatment",
  phone: "8763027916",
  phoneIntl: "+918763027916",
  whatsapp: "8249401473",
  whatsappIntl: "918249401473",
  address: "Mahima Chowk, NH 200, By Pass Road, Belpahar, Odisha, 768217",
  addressShort: "Belpahar, Odisha",
  mapsQuery: "DASH Physiotherapy Clinic, By Pass Road, Belpahar, Odisha 768217",
};

export const WHATSAPP_MSG = "Hello DASH Physiotherapy and Speech and Hearing Clinic, I would like to book an appointment.";

export const HOME_VISIT_WHATSAPP_MSG = "Hello DASH Physiotherapy & Speech and Hearing Clinic, I would like to enquire about home visit physiotherapy in Belpahar/Jharsuguda.";

export const whatsappLink = (msg = WHATSAPP_MSG) =>
  `https://wa.me/${CLINIC.whatsappIntl}?text=${encodeURIComponent(msg)}`;

export const telLink = `tel:${CLINIC.phoneIntl}`;

// Real clinic photography provided by the clinic
export const CLINIC_LOGO = "https://customer-assets-rejwkqb3.emergentagent.net/job_dash-clinic-belpahar/artifacts/uw9d411j_971fd176-bd36-4c49-aa9a-a96559af7ab3.jpeg";

export const CLINIC_PHOTOS = {
  homeVisit: "https://customer-assets-rejwkqb3.emergentagent.net/job_dash-clinic-belpahar/artifacts/zj6iieeb_3312ccd3-f792-4548-a1df-387dbde95309.jpeg",
  hearingCare: "https://customer-assets-rejwkqb3.emergentagent.net/job_dash-clinic-belpahar/artifacts/q4p0yt6b_25d9bfb4-542f-46d0-bf53-8fb91591280c.jpeg",
  signboard: "https://customer-assets-eiarnc6j.emergentagent.net/job_e2f67b7c-796e-47cd-8574-064e808bd77e/artifacts/ny9keusd_1efbb4e4-c6d2-4a0a-85dc-32eca9fbacec.jpeg",
  pediatricTherapy: "https://customer-assets-eiarnc6j.emergentagent.net/job_e2f67b7c-796e-47cd-8574-064e808bd77e/artifacts/dvzepsby_39b59a35-5dfe-4593-a83d-1520a0d531e7.jpeg",
  pediatricRoom: "https://customer-assets-eiarnc6j.emergentagent.net/job_e2f67b7c-796e-47cd-8574-064e808bd77e/artifacts/6wtjruxz_d5b04160-0948-417c-aae6-6706640705a3.jpeg",
  reception: "https://customer-assets-eiarnc6j.emergentagent.net/job_e2f67b7c-796e-47cd-8574-064e808bd77e/artifacts/f0plsa8h_c1c59f3c-065e-4b71-9f6d-0c8cbc589a2f.jpeg",
  building: "https://customer-assets-eiarnc6j.emergentagent.net/job_e2f67b7c-796e-47cd-8574-064e808bd77e/artifacts/93v2o12a_4f6588df-375b-411b-a11b-28eddb428c38.jpeg",
};

export const STOCK = {
  heroPhysio: "https://images.unsplash.com/photo-1649751361457-01d3a696c7e6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  physioManual: "https://images.unsplash.com/photo-1706353399656-210cca727a33?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  physioWrist: "https://images.unsplash.com/photo-1645005513751-e22717a66ae6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  backPain: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  speechChild: "https://images.unsplash.com/photo-1758273241260-f49172d876e3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  speechColoring: "https://images.unsplash.com/photo-1587323655395-b1c77a12c89a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  audiology: "https://images.unsplash.com/photo-1611532736579-6b16e2b50449?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  elderlyHome: "https://images.unsplash.com/photo-1584797802294-190bd128cc83?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  elderlyHands: "https://images.unsplash.com/photo-1627752885954-e6956866dcbf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Physiotherapy", to: "/physiotherapy" },
  { label: "Speech & Hearing", to: "/speech-hearing" },
  { label: "Home Visits", to: "/home-visits" },
  { label: "Our Specialists", to: "/specialists" },
  { label: "Conditions", to: "/conditions" },
  { label: "Contact", to: "/contact" },
];

export const PHYSIO_SERVICES = [
  { name: "Home Visit Physiotherapy", featured: true, desc: "Professional physiotherapy care at your home. Available primarily in Belpahar and the Jharsuguda area." },
  { name: "Pain Management", desc: "Individualized programs to help reduce pain and improve daily comfort through therapeutic techniques and guided exercise." },
  { name: "Orthopedic Physiotherapy", desc: "Focused care for muscles, bones and joints to support recovery from strains, stiffness and orthopedic concerns." },
  { name: "Back & Neck Pain", desc: "Assessment and therapy to ease back and neck discomfort, improve posture and restore comfortable movement." },
  { name: "Joint Pain & Arthritis", desc: "Supportive management for joint pain and arthritis, aimed at improving mobility and everyday function." },
  { name: "Sports Injury Rehabilitation", desc: "Structured rehabilitation to help you recover from sports-related injuries and return to activity safely." },
  { name: "Post-operative Rehabilitation", desc: "Guided recovery after surgery to help rebuild strength, movement and confidence in a supported way." },
  { name: "Neurological Rehabilitation", desc: "Therapy that supports movement, balance and functional independence for neurological conditions." },
  { name: "Pediatric Physiotherapy", desc: "Gentle, play-based physiotherapy for children to support movement, strength and developmental goals." },
  { name: "Exercise Therapy", desc: "Personalized exercise programs designed to build strength, flexibility and long-term movement health." },
  { name: "Cupping Therapy", desc: "A supportive therapy technique used to help relieve muscle tension and support recovery." },
  { name: "Dry Needling Therapy", desc: "A targeted technique used to help ease muscular tightness and support pain relief." },
  { name: "Advanced / Laser-based Therapy", desc: "Where clinically appropriate, advanced therapy modalities are used to support your treatment plan." },
];

export const SPEECH_SERVICES = [
  { name: "Speech Therapy", desc: "Personalized therapy to support clearer speech and stronger communication for children and adults." },
  { name: "Language Therapy", desc: "Support for understanding and using language, tailored to each individual's needs and goals." },
  { name: "Pediatric Speech & Language Support", desc: "Early, play-based support for children with speech and language development concerns." },
  { name: "Stammering / Stuttering Support", desc: "Techniques and guidance to support smoother, more confident communication." },
  { name: "Voice Therapy", desc: "Assessment and therapy to support healthy voice use and vocal comfort." },
  { name: "Communication Disorders", desc: "Individualized assessment and support for a range of communication difficulties." },
  { name: "Hearing Assessment", desc: "Professional hearing evaluation to understand hearing needs and guide the right care." },
  { name: "Audiology Services", desc: "Comprehensive audiology care focused on assessment and individualized guidance." },
  { name: "Hearing Rehabilitation", desc: "Support and rehabilitation to help improve listening and communication in daily life." },
];

export const HOME_VISIT_SITUATIONS = [
  { name: "Elderly Patients", icon: "UserRound" },
  { name: "Patients With Mobility Difficulties", icon: "Accessibility" },
  { name: "Post-operative Rehabilitation", icon: "Stethoscope" },
  { name: "Patients Recovering From Injury", icon: "Bandage" },
  { name: "Neurological Rehabilitation", icon: "Brain" },
  { name: "Patients Who Prefer At-Home Care", icon: "House" },
];

export const HOME_VISIT_BENEFITS = [
  { name: "Treatment in the comfort of your home", icon: "House" },
  { name: "Convenient for elderly patients", icon: "UserRound" },
  { name: "Helpful for patients with mobility difficulties", icon: "Accessibility" },
  { name: "Suitable for patients recovering after surgery or injury", icon: "Stethoscope" },
  { name: "Convenient for patients who find travelling difficult", icon: "CarFront" },
  { name: "Personalized physiotherapy and rehabilitation at home", icon: "HeartHandshake" },
];

export const HOME_VISIT_AREAS = ["Belpahar", "Jharsuguda"];

export const CONDITIONS = {
  physio: [
    "Back Pain", "Neck Pain", "Shoulder Pain", "Knee Pain", "Joint Pain",
    "Arthritis", "Sports Injuries", "Muscle & Soft Tissue Problems",
    "Mobility Problems", "Post-surgical Rehabilitation", "Neurological Rehabilitation",
  ],
  speech: [
    "Speech Delay", "Language Difficulties", "Stammering / Stuttering",
    "Voice Difficulties", "Communication Difficulties", "Hearing Difficulties",
    "Pediatric Communication Concerns",
  ],
};

export const WHY_CHOOSE = [
  { title: "Personalized Treatment", icon: "HeartHandshake", desc: "Care plans shaped around each patient's individual needs and goals." },
  { title: "Professional Care", icon: "BadgeCheck", desc: "Qualified, responsible and attentive clinical care." },
  { title: "Physiotherapy & Rehabilitation", icon: "Activity", desc: "A full range of physiotherapy and rehabilitation services." },
  { title: "Speech & Hearing Services", icon: "Ear", desc: "Dedicated speech, language and hearing care under one roof." },
  { title: "Child & Adult Care", icon: "Users", desc: "Support for both children and adults across our services." },
  { title: "Patient-Centered Approach", icon: "Handshake", desc: "Comfort, clarity and compassion at every step." },
  { title: "Convenient Location", icon: "MapPin", desc: "Easy to reach on By Pass Road, Belpahar, Odisha." },
  { title: "Appointment-Based Care", icon: "CalendarCheck", desc: "Organized, appointment-based visits for focused attention." },
];

export const SPECIALISTS = [
  {
    name: "Dr. Rashmita Dash",
    role: "Physiotherapist",
    qualification: "BPT – Utkal University",
    training: "Certified in Cupping Therapy and Dry Needling Therapy",
    desc: "Dr. Rashmita Dash provides personalized physiotherapy and rehabilitation care with a focus on helping patients manage pain, restore mobility and improve functional movement.",
  },
  {
    name: "Dr. Shivram Mishra",
    role: "Audiologist & Speech Language Pathologist",
    qualification: "",
    training: "",
    desc: "Dr. Shivram Mishra provides professional hearing and audiology care with a focus on assessment, communication support and individualized patient care.",
  },
];

export const HOURS = [
  { day: "Monday", slots: ["9:00 AM – 1:30 PM", "4:00 PM – 8:00 PM"] },
  { day: "Tuesday", slots: ["9:00 AM – 1:30 PM", "4:00 PM – 8:00 PM"] },
  { day: "Wednesday", slots: ["9:00 AM – 1:30 PM", "4:00 PM – 8:00 PM"] },
  { day: "Thursday", slots: ["9:00 AM – 1:30 PM", "4:00 PM – 8:00 PM"] },
  { day: "Friday", slots: ["9:00 AM – 1:30 PM", "4:00 PM – 8:00 PM"] },
  { day: "Saturday", slots: ["9:00 AM – 1:30 PM", "4:00 PM – 8:00 PM"] },
  { day: "Sunday", slots: ["9:00 AM – 1:30 PM"] },
];

export const SERVICE_OPTIONS = ["Physiotherapy at Clinic", "Home Visit Physiotherapy", "Speech Therapy", "Hearing / Audiology", "General Enquiry"];

// Verified from the clinic's Google Business Profile (rating extracted; Google
// hides individual review text from automated tools). Paste real reviews into
// GOOGLE_REVIEWS below (name, stars 1-5, exact text) to render review cards.
export const GOOGLE = {
  url: "https://maps.app.goo.gl/jbnD6BF7oAhZ3XyXA",
  rating: 5.0,
  label: "Rated 5.0 on Google",
};

// Only add AUTHENTIC reviews here — do not invent or modify review text.
export const GOOGLE_REVIEWS = [];
